import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { RightArrow } from 'src/components/SvgIcons';

export interface SlClickThruActionProps {
  onClick?: () => void;
  label: string;
  textSx?: SxProps<Theme>;
}

/**
 * Click through action for no data placeholders
 */
export function SlClickThruAction({ onClick, label, textSx = {} }: SlClickThruActionProps) {
  return (
    <Flex alignItems="center">
      <Text
        onClick={onClick}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline'
          },
          ...textSx
        }}
        variant="subtitle2"
      >
        {label}
      </Text>
      <RightArrow style={{ width: '12px', height: '12px', marginLeft: '4px', marginTop: '2px' }} />
    </Flex>
  );
}
